import React, { useEffect, useState } from 'react';
import { Checkbox } from 'tea-component';

import Loading from './Components/Loading';
import NoData from './Components/NoSearchData';
import TagSearchInput from './Components/TagSearchInput';
import Regions from './Components/Regions';
import Markets from './Components/Markets';
import Item from './Components/Item';
import useData from './hooks/useData';
import { COMMON } from '../contants';

import { DropDownProps, CommonProps, CustomizedProps } from './type';
import * as styles from './index.module.less';
import { getLocaleText } from '@/pages/home/components/RegionSelect/locale';

const Common = (props: CommonProps) => {
  const {
    searchValue,
    renderList,
    selectList,
    activeItem,
    globalDes,
    activeItemOnChange,
    regionSelectListOnChange,
    globalSelectOnChange,
    marketsSelectListOnChange,
    disableNoChina,
    hiddenNoChina,
    showChinese,
    globalMessageHidden,
    globalMsg,
    title,
    svgSrc,
    unidentifiedNoDataText,
  } = props;

  // const [isNoData, setIsNoData] = useState(false);
  // useEffect(() => {
  //   const temp = JSON.parse(JSON.stringify(renderList))
  //   const newRegions: any[] = temp?.regions?.filter((region: any) => {
  //     let flag = region?.name?.toLowerCase()?.includes(searchValue) || region?.cnname?.includes(searchValue);

  //     // 查找子节点中包含搜索条件的项
  //     for (const i in region?.children) {
  //       const market = region?.children[i];
  //       if (market?.name?.toLowerCase()?.includes(searchValue) || market?.cnname?.includes(searchValue)) {
  //         flag = true;
  //         break;
  //       }
  //     }
  //     return flag;
  //   });
  //   setIsNoData(newRegions?.length == 0)
  // }, [searchValue])

  return (
    <div className={styles['common-container']}>
      <Regions
        searchValue={searchValue}
        renderList={renderList}
        title={title}
        globalDes={globalDes}
        globalSelect={selectList?.global}
        regionSelectList={selectList?.regions}
        activeItem={activeItem}
        showChinese={showChinese}
        activeItemOnchange={activeItemOnChange}
        regionSelectListOnChange={regionSelectListOnChange}
        globalSelectOnChange={globalSelectOnChange}
        disableNoChina={disableNoChina}
        hiddenNoChina={hiddenNoChina}
        globalMessageHidden={globalMessageHidden}
        globalMsg={globalMsg}
      />
      <Markets
        searchValue={searchValue}
        showChinese={showChinese}
        title={title}
        marketsSelectListOnChange={marketsSelectListOnChange}
        activeItem={activeItem}
        svgSrc={props?.svgSrc}
        unidentifiedNoDataText={unidentifiedNoDataText}
      />
    </div>
  );
};

const Customized = (props: CustomizedProps) => {
  const {
    searchValue,
    title,
    renderList: renderListProps,
    recentListOnChange,
    selectList = [],
    svgSrc,
  } = props;
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [renderList, setRenderList] = useState([] as any);
  const hasData = renderList?.length > 0;

  const operationAll = (isAllChecked: boolean) => {
    if (isAllChecked) {
      recentListOnChange([]);
    } else {
      const allSelectList = renderList?.map((market: any) => market?.id);
      recentListOnChange(allSelectList);
    }
    setIsAllChecked(!isAllChecked);
  };

  useEffect(() => {
    setIsAllChecked(selectList?.length > 0);
  }, [selectList]);

  // 过滤出符合条件数据
  useEffect(() => {
    let newRenderList = renderListProps;
    if (searchValue) {
      newRenderList = newRenderList?.filter((market: any) =>
        market?.name?.toLowerCase()?.includes(searchValue?.toLowerCase()),
      );
    }
    setRenderList(newRenderList);
  }, [searchValue, renderListProps]);

  return (
    <div className={styles['customized-container']}>
      <div className={styles.title}>
        <span>
          {getLocaleText('title_popular')}
          {title[1]}
        </span>
        {hasData && (
          <span
            className={styles['operation-btn']}
            onClick={() => operationAll(isAllChecked)}
          >
            {(isAllChecked && getLocaleText('clear_all')) ||
              getLocaleText('select_all')}
          </span>
        )}
      </div>
      <div className={styles.list}>
        {(hasData && (
          <Checkbox.Group
            className={styles['customized-container-group']}
            value={selectList}
            onChange={recentListOnChange}
          >
            {renderList?.map((market: any) => (
              <Item
                {...market}
                market={true}
                key={market?.id}
                svgSrc={svgSrc}
              />
            ))}
          </Checkbox.Group>
        )) || <NoData text={getLocaleText('no_data')} />}
      </div>
    </div>
  );
};

const DropDown = (props: DropDownProps) => {
  const {
    tabs,
    result,
    searchValue,
    renderList,
    selectList,
    recentList,
    activeItem,
    activeTabId,
    setActiveTabId,
    search,
    tagOnDelete,
    activeItemOnChange,
    regionSelectListOnChange,
    globalSelectOnChange,
    marketsSelectListOnChange,
    recentListOnChange,
  } = useData({
    regions: props.list,
    recentList: props.recentList,
    onChange: props?.onChange,
    value: props?.value,
    defaultValue: props?.defaultValue,
    regionType: props?.regionType,
    deleteFlag: props?.deleteFlag,
    globalNodataText: props?.globalNodataText,
    unidentifiedNoDataText: props?.unidentifiedNoDataText,
    activeTab: props?.activeTab,
    onTabChange: props?.onTabChange,
  });
  const panelActive = props?.panelActive;
  // tab 切换
  const handleTabOnActive = (tabId: string) => {
    setActiveTabId(tabId);
  };

  return (
    <div className={styles['dropdown-container']}>
      <TagSearchInput
        activeTabId={activeTabId}
        panelActive={panelActive}
        search={search}
        onDelete={tagOnDelete}
        data={result?.tagList}
      />
      <div className={styles['tab-header']}>
        {tabs.map((tab: any) => (
          <div
            key={tab?.id}
            className={`
                ${styles['tab-header-item']}
                ${activeTabId === tab?.id && styles['active-header-item']}
              `}
            onClick={() => handleTabOnActive(tab?.id)}
          >
            <span>{tab.label}</span>
          </div>
        ))}
      </div>
      <div className={styles['tab-body']}>
        <Loading loading={props?.loading}>
          {(activeTabId === COMMON && (
            <Common
              searchValue={searchValue}
              title={props.title}
              globalDes={props.globalDes}
              renderList={renderList}
              selectList={selectList}
              activeItem={activeItem}
              showChinese={props.showChinese}
              activeItemOnChange={activeItemOnChange}
              regionSelectListOnChange={regionSelectListOnChange}
              globalSelectOnChange={globalSelectOnChange}
              marketsSelectListOnChange={marketsSelectListOnChange}
              disableNoChina={props?.disableNoChina}
              hiddenNoChina={props?.hiddenNoChina}
              globalMessageHidden={props.globalMessageHidden}
              globalMsg={props?.globalMsg}
              svgSrc={props?.svgSrc}
              unidentifiedNoDataText={props?.unidentifiedNoDataText}
            />
          )) || (
            <Customized
              searchValue={searchValue}
              title={props.title}
              renderList={recentList}
              selectList={selectList?.markets}
              recentListOnChange={recentListOnChange}
              svgSrc={props?.svgSrc}
            />
          )}
        </Loading>
      </div>
    </div>
  );
};

export default DropDown;
